// eslint-disable-next-line no-shadow
enum WindowSize {
  DESKTOP,
  TABLET,
  MOBILE,
}

export default WindowSize;
